var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',[_vm._v("perm_identity")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('p',[_vm._v(_vm._s(_vm.user.name))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }